import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import { GlobalSaveService } from "../../../@core/global-save.service";
import {HttpClient} from "@angular/common/http";
import {UserInfoService} from "../../../@core/user-info.service";
import {DialogService} from "../../../../@util/dialog/dialog.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
	selector: 'app-global-save-login-form-error',
	templateUrl: './global-save-login-form-error.component.html',
	styleUrls: ['../global-save-msg-form.component.scss']
})
export class GlobalSaveLoginFormErrorComponent implements OnInit {
	title = 'StSr Message';

	globalSaveService;

	errorMessage = '';

	constructor(
		private http: HttpClient,
		private userInfoService: UserInfoService,
		public dialog: MatDialog,
		private dialogRef: MatDialogRef<GlobalSaveLoginFormErrorComponent>,
		@Inject(MAT_DIALOG_DATA) private data: any,
		private dialogService: DialogService,
		private route: ActivatedRoute,
		private router: Router) {

	}

	ngOnInit() {
		this.errorMessage = this.data.message;
	}

	closeVisitForm() {
		this.dialogRef.close();
	}

	goToPerson() {
		this.dialogRef.close({status:true});

		this.router.navigate([`/claimants/record/${this.data.sslgId}`]);
	}
}
